import { render, staticRenderFns } from "./indivudial.page.vue?vue&type=template&id=5c3b85be&"
import script from "./indivudial.page.vue?vue&type=script&lang=js&"
export * from "./indivudial.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports